import React, { FunctionComponent } from 'react';

import Modal from '../Modal/Modal';

import styles from './CheckoutModal.scss';

type CheckoutModalProps = {
  onClose: () => void;
  url: string;
};

export const CheckoutModal: FunctionComponent<CheckoutModalProps> = ({
  onClose,
  url,
}) => {
  return (
    <Modal onCloseRequest={onClose} className={styles.modal} displayCloseButton>
      <iframe title="Checkout" src={url} className={styles.iframe}></iframe>
    </Modal>
  );
};
